import { Story } from "~types/types";

export const TRANSPORTER_CONFIGS: Record<string, any> = {
    article: {
        citylab: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "citylab",
                excludedSites: "businessweek;sponsored",
            },
        },
        equality: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "equality",
                excludedSites: "businessweek;sponsored",
            },
        },
        technology: {
            options: {
                includedSites: "technology",
                excludedSites: "businessweek;sponsored",
            },
        },
        politics: {
            options: {
                backfillFacets: "Story|All",
                excludedSites: "businessweek;sponsored",
            },
        },
        quicktake: {
            options: {
                backfillFacets: "Quicktake|All",
                includedSites: "quicktake",
                excludedSites: "businessweek;sponsored",
                resourceTypes: "Quicktake",
            },
        },
        businessweek: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "businessweek",
                excludedSites: "sponsored",
            },
        },
        gadfly: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "gadfly",
                excludedSites: "businessweek;sponsored",
            },
        },
        view: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "bview",
                excludedSites: "businessweek;sponsored",
            },
        },
        green: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "green",
                excludedSites: "businessweek;sponsored",
            },
        },
        wealth: {
            options: {
                backfillFacets: "Story|All",
                includedSites: "wealth",
                excludedSites: "businessweek;sponsored",
            },
        },
        default: {
            limit: 1,
        },
    },
    feature: {
        citylab: {
            options: {
                backfillFacets: "Feature|All",
                includedSites: "citylab",
                resourceTypes: "Feature",
                excludedSites: "businessweek;sponsored",
            },
        },
        equality: {
            options: {
                backfillFacets: "Feature|All",
                resourceTypes: "Feature",
                includedSites: "equality",
                excludedSites: "businessweek;sponsored",
            },
        },
        green: {
            options: {
                backfillFacets: "Feature|All",
                includedSites: "green",
                resourceTypes: "Feature",
                excludedSites: "businessweek;sponsored",
            },
        },
        wealth: {
            options: {
                backfillFacets: "Feature|All",
                includedSites: "wealth",
                resourceTypes: "Feature",
                excludedSites: "businessweek;sponsored",
            },
        },
        default: {
            options: {
                backfillFacets: "Feature|All",
                resourceTypes: "Feature",
                excludedSites: "businessweek;sponsored",
                maxAge: 30,
            },
        },
    },
    slideshow: {
        default: {
            options: {
                backfillFacets: "Slideshow|All",
                excludedSites: "businessweek;sponsored",
                maxAge: 30,
                resourceTypes: "Slideshow",
            },
        },
    },
    default: {
        limit: 1,
    },
};

export const getTransporterConfig = (story: Story) => {
    if (story.type && TRANSPORTER_CONFIGS[story.type]) {
        return (
            TRANSPORTER_CONFIGS[story.type][story.brand] ||
            TRANSPORTER_CONFIGS[story.type].default
        );
    }

    return TRANSPORTER_CONFIGS.default;
};
